<template>
  <section class="package">
    <div class="title-holder">
      <section class="crumb-path">
        <router-link
          class="link"
          :to="{
            name: 'printStore'
          }"
        >
          PrintStore</router-link
        >

        <inline-svg
          src="/images/icons/chevron-right-solid.svg"
          class="crumb-path-divider"
        ></inline-svg>
        <router-link
          class="link"
          :to="{
            name: 'printStoreCategory',
            params: { categoryId: this.$route.params.categoryId }
          }"
        >
          {{ categoryName }}</router-link
        >

        <inline-svg
          src="/images/icons/chevron-right-solid.svg"
          class="crumb-path-divider"
        ></inline-svg>
        <h1 class="h1-md">{{ myPackage.name }}</h1>
      </section>
      <back-button class="back-button"></back-button>

      <h1 class="mobile">{{ myPackage.name }}</h1>
    </div>

    <section class="image-container">
      <product
        v-for="(product, index) in myPackage.products"
        :key="index"
        :product="product"
        class="product"
      >
      </product>
      <div class="ph"></div>
      <div class="ph"></div>
      <div class="ph"></div>
    </section>
    <section class="info">
      <h1 class="wide">{{ myPackage.name }}</h1>

      <p class="description spec" v-html="myPackage.description"></p>
      <h2>Inhoud</h2>
      <ul class="content-list">
        <li v-for="(product, index) in myPackage.products" :key="index">
          <span class="quantity">{{ product.quantity }}x</span>
          <span>{{ product.name }}</span>
        </li>
      </ul>

      <section class="order">
        <div class="count-1" v-if="myPackage.maxOrderAmount === 1">
          <label>Aantal pakketten</label>1
        </div>
        <counter
          v-else
          title="Aantal pakketten"
          :count="quantity"
          @set-count="setQuantity"
        ></counter>
        <section class="bottom">
          <div class="price" v-if="!hidePricing">
            Prijs: {{ totalPrice }} <sup>excl. btw</sup>
          </div>
          <button class="pill-button" @click="addToCart">
            In winkelwagen
          </button>
        </section>
      </section>
    </section>
  </section>
</template>
<script>
import PrintStoreMixin from '../PrintStoreMixin'
import { getPackage } from '@/features/printstore/PrintStoreApi'
import Product from './package/product.vue'
import Counter from '@/components/ui/Counter.vue'
import { EventBus } from '@/eventbus/EventBus'
import BackButton from './BackButton.vue'
import { mapGetters, mapStores } from 'pinia'
import { usePriceTableStore } from '@/features/printstore/PriceTable.store'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  components: { Product, Counter, BackButton },
  mixins: [PrintStoreMixin],
  props: ['thePackage'],
  data() {
    return {
      myPackage: {
        name: '',
        products: []
      },
      quantity: 1,
      extraInfo: {}
    }
  },
  async mounted() {
    //if entering directky by URL, load the package details
    if (!this.thePackage) {
      this.myPackage = await getPackage(this.$route.params.packageId)
    } else {
      this.myPackage = this.thePackage
    }
    if (this.myPackage.maxOrderAmount) {
      this.quantity = this.myPackage.maxOrderAmount
    }
    this.myPackage.type = 'package'
    this.printStoreStore.currentPackageName = this.myPackage.name
  },
  beforeUnmount() {
    this.printStoreStore.currentPackageName = ''
  },
  computed: {
    ...mapStores(usePrintStoreStore, usePriceTableStore),
    hidePricing() {
      const productCode = this.myPackage.productCode || ''

      if (
        this.hidePrice ||
        !this.priceTableStore.priceTable.hasOwnProperty(productCode)
      ) {
        return true
      } else if (
        this.hideOwnPrice &&
        this.myPackage.printStoreId != this.printStoreStore.defaultPrintStoreId
      ) {
        return true
      } else {
        return false
      }
    },
    singlePrice() {
      if (
        this.myPackage.productCode &&
        // eslint-disable-next-line no-prototype-builtins
        this.priceTableStore.priceTable.hasOwnProperty(
          this.myPackage.productCode
        )
      ) {
        return this.priceTableStore.priceTable[
          this.myPackage.productCode
        ].toFixed(2)
      } else {
        return ''
      }
    },
    totalPrice() {
      if (this.singlePrice && !this.hidePrice) {
        let totalPrice = this.singlePrice * this.quantity
        totalPrice = totalPrice.toFixed(2)

        return '€ ' + totalPrice.replace('.', ',')
      } else {
        return ''
      }
    },
    categoryName() {
      if (this.$route.params.categoryId === 'shared') {
        return 'Aanbevolen'
      }
      let category = this.printStoreStore.getCategory(
        this.$route.params.categoryId
      )
      return category ? category.name : ''
    }
  },
  methods: {
    setQuantity(count) {
      this.quantity = parseInt(count)
    },
    addToCart() {
      this.myPackage.quantity = this.quantity
      this.myPackage.price = this.singlePrice
      this.printStoreStore.addToCart(this.myPackage)

      this.$router.push({
        name: 'printStoreCategory',
        params: {
          categoryId: this.$route.params.categoryId
        }
      })

      EventBus.emit('addToBasket')
    }
  },
  watch: {}
}
</script>
<style lang="scss" scoped>
.package {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: 0px 20px 60px;
  position: relative;
  align-content: flex-start;
}

.title-holder {
  padding-top: 20px;
  display: flex;
  align-items: baseline;
}

.image-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.crumb-path {
  display: none;

  .h1-md {
    display: none;
  }
}

h1 {
  font-size: 30px;
  color: var(--sub-color);
  font-size: 19px;
  font-weight: 500;
}

h1.mobile {
  padding-left: 10px;
}

h1.wide {
  display: none;
}

.title {
  font-weight: 500;
  padding-right: 5px;
}

.description {
  white-space: pre-line;
  line-height: normal;
}

.spec {
  margin-bottom: 20px;
  line-height: normal;
}

h2 {
  font-weight: 600;
  padding-bottom: 10px;
}

.ph {
  width: 135px;
}

.content-list {
  li {
    padding-bottom: 5px;
  }

  .quantity {
    padding-right: 5px;
  }
}

.order {
  margin-top: 20px;
  background-color: #f4f4f4;
  padding: 20px;
  border-radius: 8px;
}

.bottom {
  display: flex;
  margin-top: 30px;
  justify-content: space-between;

  .pill-button {
    white-space: nowrap;
    margin-left: auto;
  }
}

.price {
  padding: 5px 0;
  font-weight: 500;
  font-size: 14px;
}

.info {
  width: 100%;
}

.count-1 {
  padding-top: 5px;
}

@media only screen and (min-width: 620px) {
  .title-holder {
    padding-top: 12px;
  }
}

@media only screen and (min-width: 940px) {
  .back-button {
    display: none;
  }

  .title-holder {
    flex-direction: row;
    padding-top: 0;
    margin-top: 11px;
    flex-wrap: wrap;
    padding-bottom: 14px;
  }

  h1.mobile {
    display: none;
  }

  h1.wide {
    display: block;
    word-break: break-word;
    line-height: 30px;
    font-size: 30px;
  }

  .crumb-path {
    display: flex;
    flex-wrap: wrap;
    color: var(--sub-color);
    font-weight: 400;
    line-height: 14px;
    padding-bottom: 6px;
    align-items: baseline;
    line-height: 19px;

    h1.h1-md {
      font-size: 30px;
      color: var(--sub-color);
      display: block;
      font-size: 19px;
      font-weight: 500;
      margin: 0;
    }

    .link {
      color: var(--sub-color);
      text-decoration: none;
      display: inline-block;
    }

    .md {
      display: inline-block;
    }
  }

  .divider {
    height: 10px;
    margin: 0 9px 0 6px;

    g {
      fill: var(--sub-color);
    }
  }
}

@media only screen and (min-width: 1280px) {
  .package {
    padding: 16px 20px 60px 10px;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .title-holder {
    flex: 1 0 100%;
    padding-bottom: 20px;
    margin-top: 0;
  }

  h1.mobile {
    display: none;
  }

  .info {
    padding-left: 20px;
    flex-grow: 1;
    flex-basis: 268px;
  }

  .image-container {
    flex-shrink: 0;
    width: 466px;
  }

  .crumb-path {
    h1.h1-md {
      font-size: 0.82rem;
    }
  }
}

/* @media only screen and (min-width: 1280px) {

  .package {
    padding: 40px 20px 60px 0;
    flex-direction: row;
  }

  h1.mobile {
    display: none;
  }

  h1.wide {
    display: block;
    word-break: break-word;
  }

  .image-container {
    flex-shrink: 0;
    width: 466px;
  }

  .info {
    padding-left: 30px;
    flex-grow: 1;
  }
} */
</style>
